import { render, staticRenderFns } from "./ModalContatos.vue?vue&type=template&id=210d9692&scoped=true&"
import script from "./ModalContatos.vue?vue&type=script&lang=js&"
export * from "./ModalContatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d9692",
  null
  
)

export default component.exports